import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function createIntakeSent(id: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/sent`, payload);
}

function createIntakeMedicalRelease(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/medical_release/${formId}`, payload);
}

function createIntakeOfficePolicies(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/office_policies/${formId}`, payload);
}

function createIntakeNeuropsychologyPatient(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/neuropsychology_patient/${formId}`, payload);
}
function createIntakeReleaseOfHealthInformationPediatrician(
    id: number | string,
    formId: number | string,
    payload: any,
): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/release_of_health_information_pediatrician/${formId}`, payload);
}

function createIntakeReleaseOfHealthInformationSchool(
    id: number | string,
    formId: number | string,
    payload: any,
): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/release_of_health_information_school/${formId}`, payload);
}

function createIntakeWelcomePacket(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/welcome_packet/${formId}`, payload);
}

function createIntakeBriefBackground(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/brief_background/${formId}`, payload);
}

function createIntakeTreatmentProcess(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/treatment_process/${formId}`, payload);
}
function createIntakeInformedExpectation(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/informed_expectation/${formId}`, payload);
}
function createIntakeCreditCard(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/credit_card/${formId}`, payload);
}

function createIntakeHealthInformation(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/health_information/${formId}`, payload);
}
function createIntakeConsentForBi(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/consent_for_bi/${formId}`, payload);
}

function createIntakeAbaIntake(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/aba_intake/${formId}`, payload);
}

function createIntakeInformedConsentForTesting(
    id: number | string,
    formId: number | string,
    payload: any,
): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/informed_consent_for_testing/${formId}`, payload);
}

function createIntakeInformedConsentForVideo(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/informed_consent_for_video/${formId}`, payload);
}

function createIntakeTelemedicineConsent(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/telemedicine_consent/${formId}`, payload);
}

function createIntakeConsentTestingDoeCases(id: number | string, formId: number | string, payload: any): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/consent_testing_doe_cases/${formId}`, payload);
}

function createIntakeTreatmentInformedConsent(
    id: number | string,
    formId: number | string,
    payload: any,
): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/treatment_informed_consent/${formId}`, payload);
}

function createIntakeChildTreatmentQuestionnaire(
    id: number | string,
    formId: number | string,
    payload: any,
): AxiosPromise {
    return EndPointService.post(`/student_intakes/${id}/child_treatment_questionnaire/${formId}`, payload);
}

export default {
    createIntakeTreatmentInformedConsent,
    createIntakeTelemedicineConsent,
    createIntakeInformedConsentForTesting,
    createIntakeInformedConsentForVideo,
    createIntakeOfficePolicies,
    createIntakeMedicalRelease,
    createIntakeSent,
    createIntakeAbaIntake,
    createIntakeChildTreatmentQuestionnaire,
    createIntakeNeuropsychologyPatient,
    createIntakeConsentTestingDoeCases,
    createIntakeReleaseOfHealthInformationPediatrician,
    createIntakeReleaseOfHealthInformationSchool,
    createIntakeWelcomePacket,
    createIntakeBriefBackground,
    createIntakeTreatmentProcess,
    createIntakeInformedExpectation,
    createIntakeCreditCard,
    createIntakeConsentForBi,
    createIntakeHealthInformation,
};
